let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j4In0")).then(() => parcelRequire('eUyY3'));